import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Payslip } from "@/v2/types";

export default async function FindAllPayslip({
  limit,
  skip,
  search,
  filter,
}: {
  skip?: number;
  limit?: number;
  search?: string;
  filter?: Record<string, any>;
}): Promise<{ data: { payslips: Payslip[] }; pagination: Pagination }> {
  const res = await apiClientWithRefreshToken({
    url: "/payslips",
    method: "GET",
    params: {
      skip: skip ?? 0,
      limit: limit ?? 10,
      ...(search && { search }),
      ...filter,
    },
  });

  return res.data;
}
